export default {
  "1": "Requesting white-listing of the IP address.",
  "1011150": "Parameter RequestIP is invalid",
  "2030166": "Domain is invalid",
  "2011170": "PromotionCode is invalid"
}
